<template>
  <login-layout :title="$t('Concedi accesso alla tua area riservata.')">
    <pf-spinner v-if="authrequestState.updating" />

    <template v-else-if="authrequest?.username">
      <pf-content>
        <p>
          <i18n-t keypath="Abilitare l'utenza {user} ad accedere all'area riservata di {company} come utente di tipo amministratore?" tag="p">
            <template #user>
              <strong>
                {{ authrequest.username }}
                <template v-if="authrequest.username != authrequest.email">- &lt;{{ authrequest.email }}&gt;</template>
              </strong>
            </template>
            <template #company>
              <strong>{{ authrequest.azienda }}</strong>
            </template>
          </i18n-t>
        </p>
        <p>
          {{
            $t(
              'Ti ricordiamo che potrai modificare o revocare i permessi accordati in qualsiasi momento accedendo alla sezione "Utenze".',
            )
          }}
        </p>
      </pf-content>

      <pf-button variant="primary" large block :disabled="sending" @click="submit" :loading="sending" class="pf-v6-u-my-md">
        {{ $t('Autorizza Accesso') }}
      </pf-button>
    </template>

    <p v-else>{{ $t('La richiesta di accesso non è valida o è scaduta.') }}</p>

    <pf-button large block @click="next" variant="danger">{{ $t('Ignora') }}</pf-button>
  </login-layout>
</template>

<style lang="scss" scoped>
.btn-logout {
  margin-top: 10px;
}
</style>

<script lang="ts" setup>
import { http } from '../../http';
import { asyncComputed } from '@common/asyncComputed';
import { loginDestination } from '../../utils';
import LoginLayout from '../../components/login-layout.vue';
import { useLoginStore } from '@/store/login';
import { useFunctionRunningState } from '@common/use';
import { useRoute, useRouter } from 'vue-router';

interface AuthRequestInfo {
  azienda?: string;
  username?: string;
  email?: string;
}

interface Props {
  aid: string;
  uid: string;
  tok: string;
}

defineOptions({
  name: 'AuthorizeUserPage',
});

const props = defineProps<Props>();

const route = useRoute();
const router = useRouter();

const { result: authrequest, state: authrequestState } = asyncComputed(async() => {
  if (!props.aid || !props.uid || !props.tok) {
    return {};
  }
  return (await http.post<AuthRequestInfo>('/rest/login/authrequestinfo', {
    aid: props.aid,
    uid: props.uid,
    tok: props.tok,
  })).data;
}, null as AuthRequestInfo | null);

const { isRunning: sending, run: submit } = useFunctionRunningState(async() => {
  const data = new FormData();
  data.append('id_azienda', props.aid);
  data.append('uid', props.uid);
  data.append('tok', props.tok);

  const result = (await http.post('/api/auth/companylogin', data)).data.result;

  if (result == 'ok') {
    const login = useLoginStore();
    await login.refresh();
    next();
  }
}, { preventMultiple: true });

function next() {
  router.push(loginDestination(route.query));
}
</script>
